import { Injectable, Inject } from '@angular/core';
import { UiStore } from './ui.store';
import { DaysPlannerStore } from './day-planner.store';
import { AppConfigStore } from './app-config.store';
import { GuidesStore } from './guides.store';
import { ShoppingListStore } from './shopping-list.store';

@Injectable()
export class Store {
    constructor(
        @Inject(AppConfigStore) public appConfigStore: AppConfigStore,
        @Inject(UiStore) public uiStore: UiStore,
        @Inject(DaysPlannerStore) public daysPlannerStore: DaysPlannerStore,
        @Inject(GuidesStore) public guidesStore: GuidesStore,
        @Inject(ShoppingListStore) public shoppingListStore: ShoppingListStore,
    ){
    }
}
